import {PAYMENT_METHOD} from "../../helpers/payment/constants"

export const MOCK_POST_PAYMENT_DATA = {
  paymentMethod: PAYMENT_METHOD.SAVED_CREDIT_CARD,
  product: {
    name: "Mock Name",
    description: "Mock Description",
  },
  transaction: {
    "ab_country": "BR",
    "ab_currency": "BRL",
    "ab_payment_type": "postpay",
    "ab_refuse_reason": null,
    "ab_status": "PENDING",
    "ab_transaction_type": "IMAGE_PROCESSING",
    "boleto_bancario": {
      "dh_created": "2019-04-05T14:35:24.996500+00:00",
      "str_barcode_number": "03391749800000002509557354800007024959560102",
      "str_digitable_line": "03399557345480000702049595601029174980000000250",
      "url_boleto": "https://payment.boacompra.com/b/cnZPWTNxM1E3XVVkZXpWcWXXTzB4QT25",
    },
    "cd_external_code": "49564",
    "cd_internal_hash": "456042DC166A4B89940151D07AEBB1B2",
    "cd_price_product": 1,
    "cd_promotion": null,
    "cd_promotion_plan": null,
    "cd_reference": "IMAGE_PROCESSING-550-390-0B1D7",
    "cd_subscription_plan": null,
    "cd_user": 390,
    "dh_created": "2019-04-05T18:49:47.008243+00:00",
    "dh_finished": null,
    "dh_updated": null,
    "fl_discount": 0.0,
    "fl_final_price": 3.73,
    "fl_total_price": 3.73,
    "id_transaction": 7,
    "int_credits_used": 0,
    "price_product": {
      "ab_payable_with": "ALL",
      "fl_price_non_subscriber": 37.3,
      "fl_price_subscriber": 28.0,
      "id_price_product": 1,
    },
    "promotion": null,
    "promotion_plan": null,
    "str_transaction_email": "togokuron@mailinator.com",
    "subscription_plan": null,
  },
  cardData: {
    "creditCardLastDigits": "0002",
    "creditCardBrand": "visa",
  },
}

const defaultState = () => ({
  postPaymentData: null,
})
const state = defaultState()

// -------------- Mutations -------------- //
const MUTATIONS_TYPES = {
  SET_POST_PAYMENT_DATA: "SET_POST_PAYMENT_DATA",
  CLEAN_POST_PAYMENT: "CLEAN_POST_PAYMENT",
}

const mutations = {
  [MUTATIONS_TYPES.SET_POST_PAYMENT_DATA](state, postPaymentData) {
    state.postPaymentData = postPaymentData
  },
  [MUTATIONS_TYPES.CLEAN_POST_PAYMENT](state) {
    Object.assign(state, defaultState())
  },
}

// -------------- Getters -------------- //
export const GET_POST_PAYMENT_DATA = "GET_POST_PAYMENT_DATA"

const getters = {
  [GET_POST_PAYMENT_DATA](state) {
    return state.postPaymentData
  },
}

// -------------- Actions -------------- //
export const SET_POST_PAYMENT_DATA = "SET_POST_PAYMENT_DATA"
export const CLEAN_POST_PAYMENT = "CLEAN_POST_PAYMENT"

const actions = {
  [SET_POST_PAYMENT_DATA]({commit}, postPaymentData) {
    commit(MUTATIONS_TYPES.SET_POST_PAYMENT_DATA, postPaymentData)
  },
  [CLEAN_POST_PAYMENT]({commit}) {
    commit(MUTATIONS_TYPES.CLEAN_POST_PAYMENT)
  },
}

export default {
  mutations,
  getters,
  actions,
  state,
}
